module.exports = __webpack_public_path__ + "static/media/HR-SaaS.b86d4820.jpg";